import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from '@tolgee/react';
import { LomavisDemographicsSectionForPlatform1 } from '../../../lomavisSharedUi/templates/sections/analytics/lomavisDemographicsSectionForPlatform1';
import {
  fetchDemographics,
  extractDemographicsData
} from '../../../redux/slices/analytics/demographics';
import IsLoadingIndicator from '../../isLoadingIndicator';
import {
  ALL,
  SUPPORTED_PLATFORMS_DEMOGRAPHICS
} from '../../../config/constants';
import { resolveForNavigation } from '@/api/endPoints';
import { PATH_PAGE } from '@/routes/paths';

interface DemographicsMapProps {
  locationUuid: string;
  locationslug?: string;
  showViewMoreButton?: boolean;
}

const DemographicsMap: React.FC<DemographicsMapProps> = ({
  locationUuid,
  locationslug = null,
  showViewMoreButton = false
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { data: demographicsData, isLoading: demographicsLoading } =
    useSelector((state: any) => state.demographics);

  const [viewMoreButtonUrl, setViewMoreButtonUrl] = useState('#');

  useEffect(() => {
    if (locationslug) {
      setViewMoreButtonUrl(
        resolveForNavigation(
          PATH_PAGE.allAnalyticsDemographics,
          { locationslug },
          {},
          true
        )
      );
    }
  }, []);

  useEffect(() => {
    if (locationUuid) {
      dispatch(fetchDemographics(locationUuid) as any);
    }
  }, [dispatch, locationUuid]);

  // Extract all demographic data from "all" platform (combined data)
  const allPlatformData = extractDemographicsData(demographicsData, ALL, t);

  const { platforms_information } = useSelector(
    (state: any) => state.locationDetails
  );
  const activeSupportedPlatforms = SUPPORTED_PLATFORMS_DEMOGRAPHICS.filter(
    (platform) =>
      platforms_information &&
      Object.keys(platforms_information).includes(platform)
  );

  if (demographicsLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px'
        }}
      >
        <IsLoadingIndicator />
      </div>
    );
  }

  if (
    !allPlatformData ||
    (!allPlatformData.ageData &&
      !allPlatformData.genderData &&
      !allPlatformData.languageData &&
      !allPlatformData.seniorityData &&
      !allPlatformData.industriesData &&
      !allPlatformData.functionsData &&
      !allPlatformData.companySizesData &&
      !allPlatformData.citiesData)
  ) {
    return null;
  }

  return (
    <LomavisDemographicsSectionForPlatform1
      title={'allAnalytics.demographics.title'}
      platform={ALL}
      activeSupportedPlatforms={activeSupportedPlatforms}
      {...allPlatformData}
      hideTitle={true}
      showViewMoreButton={showViewMoreButton}
      viewMoreButtonUrl={viewMoreButtonUrl}
    />
  );
};

export default DemographicsMap;
